module.exports = __webpack_public_path__ + "static/media/zel.8d710176.svg";